import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { setAlert } from "../../actions/alertActions";

import appOne from "../../styles/images/app1crop.png";
import appTwo from "../../styles/images/app2crop.png";
import appThree from "../../styles/images/app3crop.png";

import androidPNG from "../../styles/images/Android.png";
import iosPNG from "../../styles/images/iOS.png";
import androidSVG from "../../styles/images/Android.svg";
import iosSVG from "../../styles/images/iOS.svg";

import { Translate, I18n } from "react-redux-i18n";

import { momentModule } from "../utils/Utils";

import "../../styles/components/comparator/Comparator.scss";

const { moment } = momentModule;

class Comparator extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      groups: [],

      modals: {
        pick: false,
        plug: false,
      },
    };
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchGroups();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hasOwnProperty("tempCharger"))
      if (
        this.props.tempCharger !== null &&
        (prevProps.tempCharger === null ||
          prevProps.tempCharger._id !== this.props.tempCharger._id)
      )
        this.setModal("plug", true);
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchGroups() {
    axios
      .get("/api/private/groupCSUsers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) this.safeSetState({ groups: res.data });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div>
        <div className="appImagesTitle">
          <h1>
            <Translate value="checkOutNewComparator" />
          </h1>
        </div>
        <div className="appImagesDiv" style={{ alignItems: "center" }}>
          <div>
            <img src={appOne} alt="" />
          </div>
          {this.props?.brand?.brandName === "EVIO" && (
            <a href="https://play.google.com/store/apps/details?id=com.evio.evio">
              <div className="qrcodesComparator">
                <img src={androidSVG} alt="" />
                <img src={androidPNG} alt="" />
              </div>
            </a>
          )}
          <div>
            <img src={appTwo} alt="" />
          </div>
          {this.props?.brand?.brandName === "EVIO" && (
            <a href="https://apps.apple.com/us/app/evio/id1539284689">
              <div className="qrcodesComparator">
                <img src={iosSVG} alt="" />
                <img src={iosPNG} alt="" />
              </div>
            </a>
          )}
          <div>
            <img src={appThree} alt="" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert })(Comparator);
